module.exports = __webpack_public_path__ + "img/pethouse18.73b09007.jpg";